@if ({}; as STATE) {
  <section class="advertiser-sector-creation-dialog">
    <advertiser-sector-creation-form [sector]="sector()" />
  </section>
}
